
    export default 
    {
    "footer": {
        "about": "Über uns",
        "support": "Unterstützung",
        "privacy_policy": "Datenschutz"
    }
}